import { Dialog, DialogContent, DialogTitle } from "./dialog";
import { Button } from "./button";
import { useState } from "react";

export function AddPostDialog({ open, onOpenChange, onSubmit }: any) {
  const [text, setText] = useState("");
  const [mediaFile, setMediaFile] = useState<File | null>(null);

  const resetForm = () => {
    setText("");
    setMediaFile(null);
  };

  const handleMediaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) setMediaFile(file);
  };

  const handleSubmit = () => {
    if (!text.trim() && !mediaFile) return;

    onSubmit({ text, mediaFile });
    resetForm();
    onOpenChange(false);
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      resetForm();
    }
    onOpenChange(isOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-md">
        <DialogTitle>Create Post</DialogTitle>

        <textarea
          className="w-full border rounded-lg p-3 mt-3 h-32"
          placeholder="Write something..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />

        <div className="mt-3">
          <input
            type="file"
            accept="image/*,video/*"
            onChange={handleMediaChange}
          />
        </div>

        {mediaFile && (
          <p className="text-sm text-muted-foreground mt-2">
            Attached: {mediaFile.name}
          </p>
        )}

        <div className="flex justify-end space-x-2 mt-4">
          <Button
            variant="outline"
            onClick={() => handleOpenChange(false)}
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit}>Post</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
